module.exports = __webpack_public_path__ + "static/media/largetree-cropped.67ce564c.jpg";